module.exports = __webpack_public_path__ + "img/key.fd83554e.jpg";